import React, { FC, useEffect } from 'react';
import { useAuth } from 'utils/auth';
import PageLoading from 'components/common/PageLoading';
import { SFTY_STORAGE_KEY } from 'hooks/useIsSFTYUser';

const SignOut: FC = (): JSX.Element => {
  const { isLoading, logout } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      sessionStorage.removeItem(SFTY_STORAGE_KEY);
      logout({ returnTo: window.location.origin });
    }
  }, [logout, isLoading]);

  return <PageLoading />;
};

export default SignOut;
